export default "__VITE_ASSET__8TOhRMkV__"